/*
=========================================================
* Material Kit 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Material Kit 2 React components
import MKBox from "components/MKBox";

// Material Kit 2 React examples
import RotatingCard from "examples/Cards/RotatingCard";
import RotatingCardFront from "examples/Cards/RotatingCard/RotatingCardFront";
import DefaultInfoCard from "examples/Cards/InfoCards/DefaultInfoCard";

import Icon from "@mui/material/Icon";

// Images
import bgFront from "assets/images/bg-presentation.jpg";

function Information() {
  return (
    <MKBox component="section" py={6} my={6}>
      <Container>
        <Grid container item xs={11} spacing={3} alignItems="center" sx={{ mx: "auto" }}>
          <Grid item xs={12} md={12}>
            <RotatingCard>
              <RotatingCardFront
                image={bgFront}
                icon="touch_app"
                title={<>Activités</>}
                description="Toutes les activités proposées par ANEMAR GROUPE"
              />
            </RotatingCard>
          </Grid>
          <Grid container spacing={3} mt={6}>
            <Grid item xs={12} md={6}>
              <DefaultInfoCard
                icon={<Icon>event</Icon>}
                title="OGANISATION D'ÉVÉNEMENTS"
                description="Chez ANEMAR GROUPE, nous faisons de chaque évènement une réussite exceptionnelle, pensée dans les moindres détails. Que ce soit un mariage féérique, un séminaire professionnel, un lancement de produit ou une célébration privée, nous vous accompagnons à chaque étape pour vous offrir une expérience inoubliable."
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <DefaultInfoCard
                icon={<Icon>palette</Icon>}
                title="DECORATION ET AMBIANCE"
                description="Nous créons des décors et des ambiances qui marquent les esprits et subliment vos évènements. Chaque détail est soigneusement pensé pour transformer votre espace en un cadre magique, reflétant votre style et votre thématique. Que ce soit pour un mariage somptueux, une soirée d’entreprise élégante ou un évènement privé unique, nous donnons vie à vos rêves avec créativité et expertise."
              />
            </Grid>
          </Grid>
          <Grid container spacing={3} sx={{ mt: { xs: 0, md: 6 } }}>
            <Grid item xs={12} md={6}>
              <DefaultInfoCard
                icon={<Icon>restaurant</Icon>}
                title="TRAITEUR ET ARTS CULINAIRE"
                description="Nous croyons que la gastronomie est au cœur de chaque évènement réussi. Nous vous offrons un service traiteur raffiné, alliant saveurs exquises et présentation élégante pour émerveiller vos invités. Que ce soit pour un mariage, un gala, un séminaire ou une fête privée, nos chefs passionnés mettent tout leur savoir-faire au service de vos papilles."
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <DefaultInfoCard
                icon={<Icon>checkroom</Icon>}
                title="MODES ET BEAUTÉ"
                description="Nous savons que l'apparence est essentielle pour marquer chaque moment spécial. C'est pourquoi nous proposons une prestation complète de mode et de beauté pour sublimer votre évènement, que ce soit pour une cérémonie élégante, un mariage prestigieux ou un évènement privé mémorable."
              />
            </Grid>
          </Grid>
          <Grid container spacing={3} sx={{ mt: { xs: 0, md: 6 } }}>
            <Grid item xs={12} md={6}>
              <DefaultInfoCard
                icon={<Icon>flight</Icon>}
                title="EXPERIENCE NUPTIALES"
                description="Nous savons que le début de votre aventure à deux mérite d'être aussi exceptionnel que votre grand jour. C’est pourquoi nous vous proposons des services sur mesure pour organiser la Lune de Miel de vos rêves et vous offrir un accompagnement personnalisé tout au long de cette expérience unique."
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <DefaultInfoCard
                icon={<Icon>favorite</Icon>}
                title="COACHING MATRIMONIAL"
                description="Nous comprenons que chaque mariage est une aventure unique et que chaque couple mérite le meilleur accompagnement. C'est pourquoi nous proposons un service de coaching matrimonial sur mesure, visant à renforcer les bases de votre relation et à vous aider à créer une union durable et épanouissante."
              />
            </Grid>
          </Grid>
        </Grid>
      </Container>
    </MKBox>
  );
}

export default Information;
